import React, { useState } from "react";
import play from "../../src/assets/images/play.svg";
import info from "../../src/assets/images/info.svg";
import Modal from "./Modal";
import { useNavigate } from "react-router-dom";

const VideoTitle = ({ id, title, overview }) => {
	const navigate = useNavigate();

	const [showVideoModal, setShowVideoModal] = useState(false);

	const handlePlayClick = (e) => {
		e.preventDefault();
		e.stopPropagation();
		setShowVideoModal(true);
	};

	const handleCloseModal = () => {
		setShowVideoModal(false);
	};

	const handleMovieClick = (e) => {
		// Ensure we don't navigate if clicking on interactive elements
		if (
			e.target.closest(".wishlist-icon") ||
			e.target.closest("[data-play-button]") ||
			e.target.classList.contains("wishlist-icon")
		) {
			return;
		}

		e.preventDefault();
		e.stopPropagation();

		try {
			if (e.metaKey || e.ctrlKey) {
				window.open(`/movie/${id}`, "_blank");
			} else {
				navigate(`/movie/${id}`);
			}
		} catch (error) {
			console.error("Navigation error:", error);
		}
	};

	return (
		<div className="flex justify-center h-full pt-[5%] md:pt-0 md:mt-[-2.5%] gap-4 flex-col pl-4 md:pl-8 absolute z-[1] text-white bg-gradient-to-r from-black w-screen aspect-video">
			<div className="md:max-w-[40%]">
				<h1 className="text-[clamp(1.5rem,0.582rem+2.449vw,4.5rem)]">
					{title}
				</h1>
			</div>
			<div className="flex gap-4 btn-container md:pt-4 ">
				<button
					className="flex items-center text-xs md:text-base gap-2 px-3 py-2 md:px-5 md:py-3 rounded-lg bg-white text-black hover:opacity-80"
					onClick={handlePlayClick}
				>
					<div>
						<img className="w-[16px] md:w-[24px]" src={play} alt="Play Video" />
					</div>
					<span className="2xl:text-2xl">Play</span>
				</button>
				<button
					className="flex items-center text-xs md:text-base gap-2 bg-slate-600 text-white opacity-90 px-3 py-2 md:px-5 md:py-3 rounded-lg hover:opacity-80"
					onClick={handleMovieClick}
				>
					<div>
						<img className="w-[16px] md:w-[24px]" src={info} alt="More Info" />
					</div>
					<span className="2xl:text-2xl">More Info</span>
				</button>
			</div>
			{showVideoModal && <Modal movieId={id} onClose={handleCloseModal} />}
		</div>
	);
};

export default VideoTitle;
